import { Box, Typography } from '@mui/material';
import { useProjectTypeContext } from '../useProjectTypesContext';
const NoProjectDeliverableData = () => {
  const { payload } = useProjectTypeContext();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <Typography variant="h6" color="text.secondary">
        {!payload.id
          ? 'Please select project to view deliverable types.'
          : 'No Items found.'}
      </Typography>
      <Typography color="text.secondary">
        {!payload.id ? '' : 'Add new deliverable type to view here.'}
      </Typography>
    </Box>
  );
};

export default NoProjectDeliverableData;
